// D170.7: the lines Not supplied (isNotSuppliedLine) with their reasons, and the captain's print of them.
// Presentational: the page passes the invoice's lines and its print handler (openServerPrint).
import React from 'react';
import type { ClientInvoiceItemDto } from '../../lib/clientInvoiceApi';
import { isNotSuppliedLine } from '../../utils/clientInvoiceLine';

export function NotSuppliedPanel({ items, onPrint }: { items: ClientInvoiceItemDto[]; onPrint: () => void }) {
  const lines = items.flatMap((item, index) => (isNotSuppliedLine(item) ? [{ item, no: item.lineNumber ?? index + 1 }] : []));
  return (
    <section aria-label="Not supplied" className="rounded-md border border-slate-200 bg-white p-3 text-xs no-print">
      <div className="mb-2 flex items-center gap-2">
        <h3 className="text-sm font-semibold text-slate-900">Not supplied</h3>
        <span className="flex-1" />
        <button
          type="button"
          onClick={onPrint}
          title="Open the list of items not supplied, with the reasons, for the captain (not on the invoice)"
          className="h-8 rounded border border-slate-300 bg-white px-3 font-semibold text-slate-700"
        >
          Print for captain
        </button>
      </div>
      <table className="w-full text-left">
        <thead className="text-slate-500">
          <tr>
            <th className="px-2 py-1">#</th>
            <th className="px-2 py-1">Item</th>
            <th className="px-2 py-1">Ordered</th>
            <th className="px-2 py-1">Reason</th>
          </tr>
        </thead>
        <tbody>
          {lines.map(({ item, no }) => (
            <tr key={no} className="border-t border-slate-100">
              <td className="px-2 py-1">{no}</td>
              <td className="px-2 py-1">{item.itemName || item.itemDescription}</td>
              <td className="px-2 py-1">{`${item.confirmedQuantity ?? ''} ${item.unit || ''}`.trim()}</td>
              <td className="px-2 py-1">{String(item.notSuppliedReason ?? '').trim() || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

export default NotSuppliedPanel;
